import { render, staticRenderFns } from "./ResumeDescriptionSection.vue?vue&type=template&id=22a690c2&scoped=true&"
import script from "./ResumeDescriptionSection.vue?vue&type=script&lang=js&"
export * from "./ResumeDescriptionSection.vue?vue&type=script&lang=js&"
import style0 from "./ResumeDescriptionSection.vue?vue&type=style&index=0&id=22a690c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a690c2",
  null
  
)

export default component.exports